import React from "react";
import { useState } from "react";
import dodoImage from "../../assets/img/dodo_image.png";
import "./style.css";


function Dropdown({ selected, setSelected }) {
  const [isActive, setIsActive] = useState(false);
  const options = ['Paciente', 'Cuidador', 'Professional da Saude']

  return (
    <div className="dropdown-container">
    <div className="dropdown">
      <img
        className="chatWindow--avatar"
        src={dodoImage}
        alt="dodo"
      />
      <div className="dropdown-btn" onClick={(e) =>
        setIsActive(!isActive)}>
        {selected}
        <span className="fas fa-caret-down"></span>
      </div>
      {isActive && (
        <div className="dropdown-content">
          {options.map((option) => (
            <div
              onClick={(e) => {
                setSelected(option);
                setIsActive(false);
              }}
              className="dropdown-item"
            >
              {option}
            </div>

          ))}
        </div>
      )}
    </div>
    </div>
  );
}

export default Dropdown;

